import { all, takeLatest, call, put } from 'redux-saga/effects';
import TYPE from '../actions/TYPE';
import services from '../../services';

function* list() {
  try {
    const { data } = yield call(services.marketplace.category.list);
    yield put({ type: TYPE.LIST_CATEGORY_SUCCESS, data });
  } catch (error) {
    yield put({ type: TYPE.LIST_CATEGORY_FAILED, error });
  }
}

export default function* root() {
  yield all([takeLatest(TYPE.LIST_CATEGORY, list)]);
}
